// Dependencies
import styled from 'styled-components';

const ContainerStyles = styled.div`
  position: relative;
  display: ${(props) => (props?.flex ? 'flex' : 'block')};
  flex-wrap: ${(props) => (props?.flex ? 'wrap' : 'initial')};
  align-items: ${(props) => (props?.alignItems ? props?.alignItems : '')};
  justify-content: ${(props) =>
    props?.justifyContent ? props?.justifyContent : ''};
  width: 100%;
  max-width: 125rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;

  @media (min-width: 1200px) {
    padding-left: ${(props) => (props?.fullWidth ? '3.75rem' : '7.5rem')};
    padding-right: ${(props) => (props?.fullWidth ? '3.75rem' : '7.5rem')};
  }

  @media (min-width: 1600px) {
    padding-left: ${(props) => (props?.fullWidth ? '3.75rem' : '10rem')};
    padding-right: ${(props) => (props?.fullWidth ? '3.75rem' : '10rem')};
  }
`;

export default ContainerStyles;
